import { Component } from '@angular/core';
import { MessageDisplay } from 'src/app/features/signup/models/message-display.model';

@Component({
  selector: 'app-auth-dashboard-left-side',
  templateUrl: './dashboard-left-side.component.html',
  styleUrls: ['./dashboard-left-side.component.scss'],
})
export class AuthDashboardLeftSideComponent {
  messageDisplay: MessageDisplay = {
    title: 'Bold Penguin Terminal',
    subheader: 'The effortless way to quote and bind small business insurance',
    bullets: [
      {
        body: 'Integrating your Bold Penguin Terminal with other Bold Penguin products can supercharge your growth and further streamline your workflow.',
      },
      {
        body: 'Connect the Terminal with the Bold Penguin Exchange to monetize out-of-appetite prospects and unlock new revenue streams.',
      },
      {
        body: 'Connect the Terminal with the Bold Penguin Storefront to capture online customers where and when they shop.',
      },
    ],
  };
}
